import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const AdheredServicesColumns = () => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
            <I18n component="span" id="adheredServices.link.business" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1}>
            <I18n component="span" id="adheredServices.link.alias" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1}>
            <I18n component="span" id="adheredServices.link.paymentCode" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1} />
    </>
);
export default AdheredServicesColumns;
